module.exports = __webpack_public_path__ + "img/photo_2023-06-04 10.55.39.8fdfab9f.jpeg";